import React from "react";
import { Box, useColorMode } from "native-base";
import { faAngleLeft, faMoon, faSun, faBars } from "@fortawesome/free-solid-svg-icons";

import { SpIcon } from "./Icon";
import { LogoMd } from "./Image";
import Pressable from "./Pressable";
import { Caption } from "./Typography";
import { useTopNavigationStyles } from "./styles";
import AppRoutes, { AppRouteProps, useAppNavigate } from "~/pages";
import { useAuthorization } from "~/hooks/auth";
import Loading from "./Loading";
import { useAppSettings, useSpringBigStore } from "@springbig/shared";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

type TopNavigationProps = {
    toggleMenu: () => void;
    isMenuOpen: boolean;
    isBack?: boolean;
}

const TopNavigation = (props: TopNavigationProps) => {
    const { member, walletId } = useSpringBigStore();
    const { icon, background, divider, text } = useTopNavigationStyles();
    const { colorMode, toggleColorMode } = useColorMode();
    const { location, navigate } = useAppNavigate();
    const { switchLightDarkMode, upperLeftIcon, isDisabledSideNav } = useAppSettings();
    const { isBack } = props;
    const currentPath = location.pathname;
    const goBackRoute = AppRoutes.find(route => `/${route.path}` === currentPath)?.goBackPath;
    const navigator = useNavigate();
    const { isLoadingAuth } = useAuthorization();

    if (isLoadingAuth) {
        return <Loading isLoading={isLoadingAuth} />;
    }

    const handleNavigation = (route?: string) => {
        if (isBack) {
            goBackRoute && navigate(goBackRoute);
        }
        else if (route && walletId) {
            navigator(`/w/${walletId}/${route}` as AppRouteProps, {});
        }
    };

    const onLeftIconPress = () => {
        if (upperLeftIcon) {

            if (upperLeftIcon.toUrl && member) {
                window.open(upperLeftIcon.toUrl, "_blank");
                return;
            }

            handleNavigation(upperLeftIcon.toScreen);
            return;
        }

        handleNavigation();
    }

    return (
        <Box
            flexDirection={"row"}
            justifyContent="space-between"
            alignItems="center"
            p={4}
            w={'100%'}
            zIndex={9999}
            bg={background}
            borderBottomColor={divider}
        >
            <Pressable
                onPress={onLeftIconPress}
            >
                {goBackRoute
                    ? <Box flexDirection={"row"} alignItems="center" >
                        <SpIcon color={icon} icon={faAngleLeft} />
                        <Caption
                            color={text}
                            fontSize={16}
                            text={"general.back"}
                        />
                    </Box>
                    : <LogoMd resizeMode="contain" ml={4} />}
            </Pressable>
            <Box />

            <Box alignItems={'center'} flexDirection={'row'}>
                {switchLightDarkMode && (
                    <Pressable
                        onPress={toggleColorMode}
                        borderRadius={50}
                        p={1}
                        mr={6}
                    >
                        {colorMode === 'light' ? <SpIcon
                            size={20}
                            color={icon}
                            icon={faSun}
                        /> : <SpIcon
                            color={icon}
                            size={20}
                            icon={faMoon}
                        />
                        }
                    </Pressable>
                )}
                {!isDisabledSideNav && (
                    <Pressable
                        testID="hamburger-menu"
                        borderRadius={50}
                        p={1}
                        onPress={props.toggleMenu}
                    >
                        {
                            props.isMenuOpen ?
                                <SpIcon
                                    color={icon}
                                    size={20}
                                    icon={faXmark}
                                />
                                : <SpIcon
                                    color={icon}
                                    size={20}
                                    icon={faBars}
                                />}
                    </Pressable>
                )}
            </Box>
        </Box>
    );
};

export default TopNavigation;
